import React from 'react';
import { Box, Typography, Grid, Link } from '@mui/material';
import '../assets/fonts/fonts.css';

const Footer = () => {

  return (
    <Box
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        py: 6,
      }}
    >
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} sm={4}>
          <Typography variant="h6" gutterBottom className="csc-title">
            CSC VTC Luberon
          </Typography>
          <Typography variant="body2" className="slogan">
            Au plaisir de vous conduire.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography variant="h6" gutterBottom className="elegant-font" sx={{ color: 'white' }}>
            Liens rapides
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Link href="#accueil" color="inherit" sx={{ display: 'block', mb: 1 }}>
              Accueil
            </Link>
            <Link href="#services" color="inherit" sx={{ display: 'block', mb: 1 }}>
              Services
            </Link>
            <Link href="#contact" color="inherit" sx={{ display: 'block' }}>
              Contact
            </Link>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography variant="h6" gutterBottom className="elegant-font" sx={{ color: 'white' }}>
            Contact
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Link 
              href="tel:+33789202711" 
              color="inherit" 
              sx={{ display: 'block', mb: 1, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            >
              07 89 20 27 11
            </Link>
            <Link 
              href="mailto:sascscvtc@gmail.com" 
              color="inherit" 
              sx={{ display: 'block', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            >
              sascscvtc@gmail.com
            </Link>
          </Box>
        </Grid>
      </Grid>
      <Box sx={{ mt: 4, pt: 2, borderTop: 1, borderColor: 'primary.light' }}>
        <Typography variant="body2" align="center" className="elegant-font" sx={{ fontSize: '0.9rem' }}>
          © {new Date().getFullYear()} CSC VTC Luberon. Tous droits réservés.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
